export default function AboutCTA() {
  const handleBookCall = () => {
    const bookSection = document.getElementById('book-review');
    if (bookSection) {
      bookSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.REACT_APP_NAVIGATE('/#book-review');
    }
  };

  return (
    <section className="py-20 lg:py-28 bg-card relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[100px]"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-display text-foreground mb-6">
          Ready to <span className="gradient-text">break through</span>?
        </h2>
        <p className="text-muted-foreground text-lg mb-10 max-w-xl mx-auto">
          Let's talk about what's slowing your business down — and how we can fix it.
        </p>
        <button
          onClick={handleBookCall}
          className="inline-flex items-center gap-3 px-8 py-4 bg-primary text-primary-foreground text-lg font-semibold rounded-lg hover:opacity-90 transition-all cursor-pointer glow-primary whitespace-nowrap"
        >
          Book a Free Strategy Call
          <i className="ri-arrow-right-line"></i>
        </button>
      </div>
    </section>
  );
}